<div class="side-nav-body">
    <div class="align-right">
      <button [title]="'common.close' | translate" mat-icon-button attr.aria-label="{{'aria.close_side_menu' | translate}}" (click)="closeDrawer.emit()">
        <i class="fas fa-times"></i>
      </button>
        <router-outlet name="sidebar"></router-outlet>
    </div>
</div>
